// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* My Courses — shared student/admin theme (not a Home replica) */

.mycourses-page,
.mycourses-fee-overlay {
  --mc-bg: #fbfbfd;
  --mc-ink: #1f1b2e;
  --mc-muted: #55515f;
  --mc-soft: #6f7588;
  --mc-pink: #f2c4c4;
  --mc-peach: #f9e1be;
  --mc-mint: #bff1db;
  --mc-lavender: #d5d1fd;
  --mc-panel: #f4f2f8;
  --mc-surface: #ffffff;
  --mc-line: rgba(31, 27, 46, 0.1);
  --mc-line-soft: rgba(143, 155, 175, 0.16);
  --mc-shadow: 0 10px 24px rgba(52, 62, 94, 0.06);
  --mc-radius: 20px;
  --mc-radius-sm: 14px;
  --mc-section-x: 5%;
  --mc-max: 100%;
}

.mycourses-page {
  min-height: calc(100vh - 80px);
  padding: 1.35rem var(--mc-section-x) 3rem;
  background:
    radial-gradient(900px 420px at 8% -10%, rgba(249, 225, 190, 0.35), transparent 55%),
    radial-gradient(720px 380px at 96% 0%, rgba(213, 209, 253, 0.28), transparent 50%),
    var(--mc-bg);
  color: var(--mc-ink);
}

.mycourses-page__inner {
  width: 100%;
  max-width: var(--mc-max);
  margin: 0 auto;
}

.mycourses-header {
  margin-bottom: 1.5rem;
}

.mycourses-header__eyebrow {
  margin: 0 0 0.4rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--mc-muted);
}

.mycourses-header__title {
  position: relative;
  display: inline-block;
  margin: 0;
  padding-bottom: 0.65rem;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.6rem, 3vw, 2.1rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--mc-ink);
}

.mycourses-header__title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 3rem;
  height: 3px;
  border-radius: 999px;
  background: var(--mc-peach);
  box-shadow: 0 0 0 3px rgba(249, 225, 190, 0.35);
}

.mycourses-header__lede {
  margin: 0.75rem 0 0;
  max-width: 36rem;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--mc-muted);
  font-weight: 500;
}

.mycourses-panel--account {
  padding: 1.15rem 1.25rem 1.2rem;
}

.mycourses-account {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem 1.25rem;
}

.mycourses-account__main {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  min-width: min(100%, 18rem);
  flex: 1 1 16rem;
}

.mycourses-account__intro {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.55rem 0.75rem;
}

.mycourses-account__name {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.2rem, 2.2vw, 1.45rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--mc-ink);
}

.mycourses-account__chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
}

.mycourses-account__stats {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.5rem;
  margin: 0;
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--mc-muted);
}

.mycourses-account__stat--due {
  color: #8a3030;
  font-weight: 750;
}

.mycourses-account__due {
  margin: 0;
  font-size: 0.86rem;
  font-weight: 700;
  color: #7a2828;
}

.mycourses-fee-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0.55rem;
  flex: 0 1 auto;
}

.mycourses-fee-action {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.15rem;
  min-width: 9.5rem;
  margin: 0;
  padding: 0.7rem 0.9rem;
  border-radius: 12px;
  border: 1px solid rgba(31, 27, 46, 0.14);
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease,
    transform 0.15s ease;
}

.mycourses-fee-action:hover {
  transform: translateY(-1px);
}

.mycourses-fee-action__label {
  font-size: 0.92rem;
  font-weight: 750;
  color: var(--mc-ink);
}

.mycourses-fee-action__meta {
  font-size: 0.78rem;
  line-height: 1.3;
  color: var(--mc-muted);
}

.mycourses-fee-action--history {
  background: #fff;
  border-color: rgba(31, 27, 46, 0.16);
}

.mycourses-fee-action--history:hover {
  background: #f7f7f9;
  border-color: rgba(31, 27, 46, 0.28);
}

.mycourses-fee-action--pay {
  border-color: rgba(180, 70, 70, 0.35);
}

.mycourses-fee-action--pay:hover {
  background: #fcf6f6;
  border-color: rgba(180, 70, 70, 0.55);
}

.mycourses-fee-action--pay.mycourses-fee-action--warn {
  border-color: rgba(180, 130, 40, 0.4);
}

.mycourses-fee-action--pay.mycourses-fee-action--warn:hover {
  background: #fbf7f0;
}

.mycourses-fee-action--pay.mycourses-fee-action--urgent,
.mycourses-fee-action--pay.mycourses-fee-action--critical {
  border-color: rgba(180, 70, 70, 0.45);
}

.mycourses-fee-action--pay.mycourses-fee-action--critical .mycourses-fee-action__label {
  color: #7a2828;
}

.mycourses-stack {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.mycourses-skeleton {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.mycourses-skeleton__bar,
.mycourses-skeleton__panel {
  border-radius: var(--mc-radius);
  background: linear-gradient(
    90deg,
    rgba(244, 242, 248, 0.9),
    rgba(249, 225, 190, 0.35),
    rgba(244, 242, 248, 0.9)
  );
  background-size: 200% 100%;
  animation: mycourses-shimmer 1.4s ease-in-out infinite;
}

.mycourses-skeleton__bar {
  height: 4.5rem;
}

.mycourses-skeleton__panel {
  height: 12rem;
}

.mycourses-skeleton__label {
  margin: 0.25rem 0 0;
  text-align: center;
  color: var(--mc-muted);
  font-size: 0.9rem;
}

@keyframes mycourses-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.mycourses-panel {
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid var(--mc-line-soft);
  border-radius: var(--mc-radius);
  padding: 1.25rem 1.35rem;
  box-shadow: var(--mc-shadow);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.mycourses-panel--courses {
  background: rgba(255, 255, 255, 0.92);
}

.mycourses-panel__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--mc-line);
}

.mycourses-panel__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--mc-ink);
}

.mycourses-panel__meta {
  color: var(--mc-soft);
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.mycourses-meta-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.65rem 0.85rem;
}

.mycourses-meta-grid--details {
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.mycourses-meta {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  padding: 0.7rem 0.85rem;
  border-radius: var(--mc-radius-sm);
  background: rgba(245, 247, 252, 0.95);
  border: 1px solid rgba(143, 155, 175, 0.12);
}

.mycourses-meta__label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--mc-soft);
}

.mycourses-meta__value {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--mc-ink);
  word-break: break-word;
}

.mycourses-meta--accent {
  background: rgba(249, 225, 190, 0.45);
  border-color: rgba(249, 225, 190, 0.8);
}

.mycourses-meta--warn {
  background: rgba(242, 196, 196, 0.4);
  border-color: rgba(242, 196, 196, 0.75);
}

.mycourses-fee {
  margin-top: 1.15rem;
  padding: 1rem 1.1rem;
  border-radius: var(--mc-radius-sm);
  background: linear-gradient(
    135deg,
    rgba(249, 225, 190, 0.55),
    rgba(242, 196, 196, 0.35)
  );
  border: 1px solid rgba(242, 196, 196, 0.55);
}

.mycourses-fee__title {
  margin: 0 0 0.4rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--mc-ink);
}

.mycourses-fee__copy {
  margin: 0 0 0.85rem;
  font-size: 0.9rem;
  line-height: 1.45;
  color: #3f4558;
}

.mycourses-fee__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  margin-bottom: 0.9rem;
}

.mycourses-fee__stat strong {
  display: block;
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--mc-soft);
  margin-bottom: 0.15rem;
}

.mycourses-fee__stat span {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--mc-ink);
}

.mycourses-upload {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.mycourses-upload__label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.mycourses-upload__input {
  flex: 1 1 220px;
  min-width: 0;
  padding: 0.6rem 0.75rem;
  border-radius: 10px;
  border: 1px solid var(--mc-line-soft);
  background: var(--mc-surface);
  color: var(--mc-ink);
  font-size: 0.9rem;
}

.mycourses-upload__input:focus {
  outline: 2px solid rgba(213, 209, 253, 0.9);
  outline-offset: 1px;
}

.mycourses-upload__btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.65rem 1.25rem;
  border: none;
  border-radius: 10px;
  background: #2c3140;
  color: #fff;
  font-weight: 600;
  font-size: 0.92rem;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease, opacity 0.15s ease;
}

.mycourses-upload__btn:hover:not(:disabled) {
  background: #1f2430;
  transform: translateY(-1px);
}

.mycourses-upload__btn:focus-visible {
  outline: 2px solid rgba(213, 209, 253, 0.95);
  outline-offset: 2px;
}

.mycourses-upload__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.mycourses-upload__filename {
  margin: 0.55rem 0 0;
  font-size: 0.82rem;
  color: #3f4558;
  word-break: break-all;
}

.mycourses-fee__note {
  margin: 0.75rem 0 0;
  font-size: 0.85rem;
  line-height: 1.4;
  color: #5a5568;
}

.mycourses-subsection {
  margin-top: 0.2rem;
  padding: 0.95rem 1rem 1.05rem;
  border-radius: 16px;
  background: rgba(248, 249, 252, 0.85);
  border: 1px solid rgba(143, 155, 175, 0.12);
}

.mycourses-subsection + .mycourses-subsection {
  margin-top: 0.85rem;
}

.mycourses-subsection__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
}

.mycourses-subsection__label {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mc-ink);
}

.mycourses-subsection__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.6rem;
  height: 1.6rem;
  padding: 0 0.45rem;
  border-radius: 999px;
  background: var(--mc-lavender);
  color: var(--mc-ink);
  font-size: 0.75rem;
  font-weight: 700;
}

.mycourses-subsection__hint {
  margin: 0 0 0.75rem;
  font-size: 0.84rem;
  line-height: 1.4;
  color: var(--mc-muted);
}

.mycourses-course-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1rem;
}

.mycourses-course-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  min-width: 0;
  min-height: 100%;
  padding: 1.05rem 1.1rem 1.05rem 1.2rem;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(143, 155, 175, 0.14);
  box-shadow: 0 8px 20px rgba(52, 62, 94, 0.05);
  text-align: left;
  overflow: hidden;
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.18s ease;
}

.mycourses-course-card:hover {
  border-color: rgba(213, 209, 253, 0.75);
  box-shadow: 0 14px 28px rgba(52, 62, 94, 0.1);
  transform: translateY(-2px);
}

.mycourses-course-card__accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: var(--mc-lavender);
}

.mycourses-course-card--enrolled .mycourses-course-card__accent {
  background: var(--mc-mint);
}

.mycourses-course-card--pending .mycourses-course-card__accent {
  background: var(--mc-peach);
}

.mycourses-course-card--dropped .mycourses-course-card__accent,
.mycourses-course-card--unenrolled .mycourses-course-card__accent {
  background: var(--mc-pink);
}

.mycourses-course-card--transferred .mycourses-course-card__accent {
  background: #c5d4f5;
}

.mycourses-course-card__header {
  display: flex;
  align-items: flex-start;
  min-width: 0;
}

.mycourses-course-card__heading {
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.mycourses-course-card__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.55rem;
}

.mycourses-course-card__title {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.3;
  color: var(--mc-ink);
}

.mycourses-course-card__teacher {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #3f4558;
}

.mycourses-course-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.mycourses-soft-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
  font-size: 0.84rem;
  font-weight: 700;
  line-height: 1.2;
  color: #2c3140;
}

.mycourses-soft-chip--mint {
  background: rgba(191, 241, 219, 0.8);
  color: #1f3d32;
}

.mycourses-soft-chip--peach {
  background: rgba(249, 225, 190, 0.9);
  color: #5a4020;
}

.mycourses-soft-chip--lavender {
  background: rgba(213, 209, 253, 0.85);
  color: #3a3560;
}

.mycourses-course-card__facts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.55rem;
  padding: 0.75rem;
  border-radius: 14px;
  background: rgba(248, 249, 252, 0.95);
  border: 1px solid rgba(143, 155, 175, 0.12);
}

.mycourses-course-card__fact {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.mycourses-course-card__fact--wide {
  grid-column: 1 / -1;
}

.mycourses-course-card__fact-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--mc-soft);
}

.mycourses-course-card__fact-value {
  font-size: 1.02rem;
  font-weight: 600;
  color: #2c3140;
  word-break: break-word;
}

.mycourses-course-card__times {
  white-space: pre-line;
  line-height: 1.45;
}

.mycourses-course-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: auto;
  padding-top: 0.15rem;
}

.mycourses-course-card__link,
.mycourses-course-card__drop {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.52rem 0.9rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease, opacity 0.15s ease;
}

.mycourses-course-card__link {
  background: var(--mc-lavender);
  color: var(--mc-ink);
}

.mycourses-course-card__link:hover {
  background: #d5d1fd;
  color: var(--mc-ink);
  text-decoration: none;
  transform: translateY(-1px);
}

.mycourses-course-card__link--fee-due {
  background: rgba(249, 225, 190, 0.85);
  border-color: rgba(212, 161, 92, 0.45);
}

.mycourses-course-card__link--fee-due:hover {
  background: rgba(249, 225, 190, 1);
}

.mycourses-course-card__drop {
  background: rgba(242, 196, 196, 0.55);
  color: #5a3030;
  border-color: rgba(242, 196, 196, 0.9);
}

.mycourses-course-card__drop:hover:not(:disabled) {
  background: rgba(242, 196, 196, 0.85);
  transform: translateY(-1px);
}

.mycourses-course-card__drop:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.mycourses-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.28rem 0.65rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.2;
  flex-shrink: 0;
}

.mycourses-chip--enrolled {
  background: var(--mc-mint);
  color: #1f3d32;
}

.mycourses-chip--pending {
  background: var(--mc-peach);
  color: #5a4020;
}

.mycourses-chip--dropped,
.mycourses-chip--unenrolled {
  background: var(--mc-pink);
  color: #5a3030;
}

.mycourses-chip--transferred {
  background: #c5d4f5;
  color: #24365f;
}

.mycourses-chip--other {
  background: var(--mc-panel);
  color: #3f4558;
}

.mycourses-chip--paid {
  background: var(--mc-mint);
  color: #1f3d32;
}

.mycourses-chip--unpaid {
  background: var(--mc-pink);
  color: #5a3030;
}

.mycourses-page--loading {
  display: flex;
  height: calc(100vh - 80px);
  min-height: calc(100vh - 80px);
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
}

.mycourses-page--loading .mycourses-page__inner {
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 100%;
}

.mycourses-page--loading .mycourses-loading {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 100%;
}

.mycourses-empty,
.mycourses-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.65rem;
  padding: 2.5rem 1.5rem;
  border-radius: var(--mc-radius);
  background: rgba(255, 255, 255, 0.76);
  border: 1px dashed rgba(143, 155, 175, 0.28);
  color: var(--mc-muted);
  box-shadow: none;
}

.mycourses-loading {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  width: 100%;
  height: calc(100vh - 80px);
  min-height: calc(100vh - 80px);
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  color: var(--mc-muted);
  overflow: hidden;
}

.mycourses-loading .education-loader {
  width: 100%;
  height: 100%;
  background: transparent;
}

.mycourses-empty__title,
.mycourses-error__title {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--mc-ink);
}

.mycourses-empty__copy,
.mycourses-error__copy {
  margin: 0;
  max-width: 28rem;
  font-size: 0.95rem;
  line-height: 1.5;
}

.mycourses-empty__cta,
.mycourses-error__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.35rem;
  padding: 0.65rem 1.2rem;
  border-radius: 10px;
  border: none;
  background: var(--mc-lavender);
  color: var(--mc-ink);
  font-weight: 600;
  font-size: 0.92rem;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}

.mycourses-empty__cta:hover,
.mycourses-error__cta:hover {
  background: #d5d1fd;
  color: var(--mc-ink);
  text-decoration: none;
  transform: translateY(-1px);
}

.mycourses-empty__link {
  margin-top: 0.15rem;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--mc-muted);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.mycourses-empty__link:hover {
  color: var(--mc-ink);
}

.mycourses-subsection-empty {
  margin: 0;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  background: rgba(245, 247, 252, 0.7);
  border: 1px dashed rgba(143, 155, 175, 0.28);
  color: var(--mc-soft);
  font-size: 0.88rem;
}

/* Fee warning dialog */
.mycourses-fee-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: safe center;
  justify-content: center;
  padding: 1.5rem;
  overflow-y: auto;
  background: rgba(18, 16, 26, 0.52);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.mycourses-fee-dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 520px);
  max-height: min(90vh, 680px);
  margin: auto;
  background: #fff;
  color: var(--mc-ink);
  border: 1px solid var(--mc-line);
  border-radius: var(--mc-radius);
  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.28);
  overflow: hidden;
}

.mycourses-fee-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1.2rem 1.35rem 1rem;
  border-bottom: 1px solid var(--mc-line);
  border-left: 4px solid #c45c5c;
  background: #fff;
}

.mycourses-fee-dialog__header-text {
  min-width: 0;
}

.mycourses-fee-dialog__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(31, 27, 46, 0.12);
  border-radius: 999px;
  background: #f4f4f6;
  color: #1f1b2e;
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease;
}

.mycourses-fee-dialog__close:hover {
  background: #ebebef;
}

.mycourses-fee-dialog__eyebrow {
  margin: 0 0 0.3rem;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #8a3030;
}

.mycourses-fee-dialog__title {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.3rem, 2.4vw, 1.5rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--mc-ink);
}

.mycourses-fee-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 1.15rem 1.35rem 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.mycourses-fee-dialog__intro {
  margin: 0;
  font-size: 0.92rem;
  line-height: 1.45;
  color: #3f4558;
}

.mycourses-fee-dialog__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.mycourses-fee-dialog__list li {
  padding: 0.65rem 0.8rem;
  border-radius: 10px;
  background: #f7f7f9;
  border: 1px solid rgba(31, 27, 46, 0.1);
  font-size: 0.92rem;
  font-weight: 650;
  color: var(--mc-ink);
}

.mycourses-fee-dialog__amount-card {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.85rem 0.95rem;
  border-radius: 12px;
  border: 1px solid rgba(180, 70, 70, 0.28);
  background: #fff;
}

.mycourses-fee-dialog__amount-label {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #8a3030;
}

.mycourses-fee-dialog__amount-value {
  font-family: "Merriweather", Georgia, serif;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--mc-ink);
}

.mycourses-fee-dialog__disclaimer {
  margin: 0;
  padding: 0.75rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(31, 27, 46, 0.1);
  background: #fafafa;
  font-size: 0.88rem;
  line-height: 1.5;
  color: #3f4558;
}

.mycourses-fee-dialog__wait {
  padding: 0.85rem 0.95rem;
  border-radius: 12px;
  border: 1px solid rgba(31, 27, 46, 0.12);
  background: #f7f7f9;
}

.mycourses-fee-dialog__wait-label {
  margin: 0 0 0.55rem;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--mc-soft);
}

.mycourses-fee-dialog .timer-container {
  max-width: none;
  margin: 0;
  text-align: left;
}

.mycourses-fee-dialog .timer-text {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--mc-ink);
  margin-bottom: 0.5rem;
}

.mycourses-fee-dialog .progress-bar {
  height: 8px;
  background: rgba(31, 27, 46, 0.08);
  border-radius: 999px;
  overflow: hidden;
}

.mycourses-fee-dialog .progress {
  background: #c48a3a;
  border-radius: 999px;
}

.mycourses-fee-dialog__continue {
  width: 100%;
  margin-top: 0.15rem;
  padding: 0.8rem 1rem;
  border: 1px solid transparent;
  border-radius: 10px;
  background: #d8d8de;
  color: #6f7588;
  font-weight: 750;
  font-size: 0.95rem;
  cursor: not-allowed;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease,
    opacity 0.15s ease, transform 0.15s ease;
}

.mycourses-fee-dialog__continue--ready,
.mycourses-fee-dialog__continue:not(:disabled) {
  background: var(--mc-lavender);
  border-color: rgba(90, 80, 160, 0.22);
  color: var(--mc-ink);
  cursor: pointer;
}

.mycourses-fee-dialog__continue--ready:hover,
.mycourses-fee-dialog__continue:hover:not(:disabled) {
  background: #d5d1fd;
  transform: translateY(-1px);
}

.mycourses-fee-dialog__continue:disabled {
  opacity: 1;
}

.mycourses-fee-dialog__continue:focus-visible {
  outline: 2px solid rgba(213, 209, 253, 0.95);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .mycourses-skeleton__bar,
  .mycourses-skeleton__panel,
  .mycourses-course-card,
  .mycourses-upload__btn,
  .mycourses-course-card__link,
  .mycourses-course-card__drop {
    animation: none;
    transition: none;
  }
}

@media (max-width: 1100px) {
  .mycourses-meta-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .mycourses-page {
    padding: 1rem 5% 2.5rem;
  }

  .mycourses-panel {
    padding: 1rem;
  }

  .mycourses-panel--account {
    padding: 1rem;
  }

  .mycourses-account {
    align-items: stretch;
  }

  .mycourses-fee-actions {
    width: 100%;
  }

  .mycourses-fee-action {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 0.3rem);
    min-width: 0;
  }

  .mycourses-meta-grid {
    grid-template-columns: 1fr;
  }

  .mycourses-panel__head {
    flex-direction: column;
    align-items: flex-start;
  }

  .mycourses-upload {
    flex-direction: column;
    align-items: stretch;
  }

  .mycourses-upload__btn {
    width: 100%;
  }

  .mycourses-course-grid {
    grid-template-columns: 1fr;
  }

  .mycourses-subsection {
    padding: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/MyCourses.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,yCAAyC;EACzC,+CAA+C;EAC/C,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC;;;gBAGc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB,2CAA2C;EAC3C,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,+BAA+B;EAC/B;;;;;GAKC;EACD,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC;;;;GAIC;EACD,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;EAChB;;;wBAGsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;EAC/B,qCAAqC;EACrC,4CAA4C;EAC5C,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;EAC1B,8BAA8B;EAC9B,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,SAAS;EACT,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,uDAAuD;AACzD;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,4CAA4C;EAC5C,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,+BAA+B;EAC/B,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,4BAA4B;EAC5B,uCAAuC;EACvC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB;4CAC0C;AAC5C;;AAEA;;EAEE,8BAA8B;EAC9B,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE;;;;;;IAME,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* My Courses — shared student/admin theme (not a Home replica) */\n\n.mycourses-page,\n.mycourses-fee-overlay {\n  --mc-bg: #fbfbfd;\n  --mc-ink: #1f1b2e;\n  --mc-muted: #55515f;\n  --mc-soft: #6f7588;\n  --mc-pink: #f2c4c4;\n  --mc-peach: #f9e1be;\n  --mc-mint: #bff1db;\n  --mc-lavender: #d5d1fd;\n  --mc-panel: #f4f2f8;\n  --mc-surface: #ffffff;\n  --mc-line: rgba(31, 27, 46, 0.1);\n  --mc-line-soft: rgba(143, 155, 175, 0.16);\n  --mc-shadow: 0 10px 24px rgba(52, 62, 94, 0.06);\n  --mc-radius: 20px;\n  --mc-radius-sm: 14px;\n  --mc-section-x: 5%;\n  --mc-max: 100%;\n}\n\n.mycourses-page {\n  min-height: calc(100vh - 80px);\n  padding: 1.35rem var(--mc-section-x) 3rem;\n  background:\n    radial-gradient(900px 420px at 8% -10%, rgba(249, 225, 190, 0.35), transparent 55%),\n    radial-gradient(720px 380px at 96% 0%, rgba(213, 209, 253, 0.28), transparent 50%),\n    var(--mc-bg);\n  color: var(--mc-ink);\n}\n\n.mycourses-page__inner {\n  width: 100%;\n  max-width: var(--mc-max);\n  margin: 0 auto;\n}\n\n.mycourses-header {\n  margin-bottom: 1.5rem;\n}\n\n.mycourses-header__eyebrow {\n  margin: 0 0 0.4rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--mc-muted);\n}\n\n.mycourses-header__title {\n  position: relative;\n  display: inline-block;\n  margin: 0;\n  padding-bottom: 0.65rem;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.6rem, 3vw, 2.1rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--mc-ink);\n}\n\n.mycourses-header__title::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 3rem;\n  height: 3px;\n  border-radius: 999px;\n  background: var(--mc-peach);\n  box-shadow: 0 0 0 3px rgba(249, 225, 190, 0.35);\n}\n\n.mycourses-header__lede {\n  margin: 0.75rem 0 0;\n  max-width: 36rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: var(--mc-muted);\n  font-weight: 500;\n}\n\n.mycourses-panel--account {\n  padding: 1.15rem 1.25rem 1.2rem;\n}\n\n.mycourses-account {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1rem 1.25rem;\n}\n\n.mycourses-account__main {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  min-width: min(100%, 18rem);\n  flex: 1 1 16rem;\n}\n\n.mycourses-account__intro {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.55rem 0.75rem;\n}\n\n.mycourses-account__name {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.2rem, 2.2vw, 1.45rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--mc-ink);\n}\n\n.mycourses-account__chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.mycourses-account__stats {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem 0.5rem;\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: var(--mc-muted);\n}\n\n.mycourses-account__stat--due {\n  color: #8a3030;\n  font-weight: 750;\n}\n\n.mycourses-account__due {\n  margin: 0;\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: #7a2828;\n}\n\n.mycourses-fee-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: 0.55rem;\n  flex: 0 1 auto;\n}\n\n.mycourses-fee-action {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 0.15rem;\n  min-width: 9.5rem;\n  margin: 0;\n  padding: 0.7rem 0.9rem;\n  border-radius: 12px;\n  border: 1px solid rgba(31, 27, 46, 0.14);\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease,\n    transform 0.15s ease;\n}\n\n.mycourses-fee-action:hover {\n  transform: translateY(-1px);\n}\n\n.mycourses-fee-action__label {\n  font-size: 0.92rem;\n  font-weight: 750;\n  color: var(--mc-ink);\n}\n\n.mycourses-fee-action__meta {\n  font-size: 0.78rem;\n  line-height: 1.3;\n  color: var(--mc-muted);\n}\n\n.mycourses-fee-action--history {\n  background: #fff;\n  border-color: rgba(31, 27, 46, 0.16);\n}\n\n.mycourses-fee-action--history:hover {\n  background: #f7f7f9;\n  border-color: rgba(31, 27, 46, 0.28);\n}\n\n.mycourses-fee-action--pay {\n  border-color: rgba(180, 70, 70, 0.35);\n}\n\n.mycourses-fee-action--pay:hover {\n  background: #fcf6f6;\n  border-color: rgba(180, 70, 70, 0.55);\n}\n\n.mycourses-fee-action--pay.mycourses-fee-action--warn {\n  border-color: rgba(180, 130, 40, 0.4);\n}\n\n.mycourses-fee-action--pay.mycourses-fee-action--warn:hover {\n  background: #fbf7f0;\n}\n\n.mycourses-fee-action--pay.mycourses-fee-action--urgent,\n.mycourses-fee-action--pay.mycourses-fee-action--critical {\n  border-color: rgba(180, 70, 70, 0.45);\n}\n\n.mycourses-fee-action--pay.mycourses-fee-action--critical .mycourses-fee-action__label {\n  color: #7a2828;\n}\n\n.mycourses-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.mycourses-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.mycourses-skeleton__bar,\n.mycourses-skeleton__panel {\n  border-radius: var(--mc-radius);\n  background: linear-gradient(\n    90deg,\n    rgba(244, 242, 248, 0.9),\n    rgba(249, 225, 190, 0.35),\n    rgba(244, 242, 248, 0.9)\n  );\n  background-size: 200% 100%;\n  animation: mycourses-shimmer 1.4s ease-in-out infinite;\n}\n\n.mycourses-skeleton__bar {\n  height: 4.5rem;\n}\n\n.mycourses-skeleton__panel {\n  height: 12rem;\n}\n\n.mycourses-skeleton__label {\n  margin: 0.25rem 0 0;\n  text-align: center;\n  color: var(--mc-muted);\n  font-size: 0.9rem;\n}\n\n@keyframes mycourses-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.mycourses-panel {\n  background: rgba(255, 255, 255, 0.88);\n  border: 1px solid var(--mc-line-soft);\n  border-radius: var(--mc-radius);\n  padding: 1.25rem 1.35rem;\n  box-shadow: var(--mc-shadow);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.mycourses-panel--courses {\n  background: rgba(255, 255, 255, 0.92);\n}\n\n.mycourses-panel__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid var(--mc-line);\n}\n\n.mycourses-panel__title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--mc-ink);\n}\n\n.mycourses-panel__meta {\n  color: var(--mc-soft);\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.mycourses-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.65rem 0.85rem;\n}\n\n.mycourses-meta-grid--details {\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n}\n\n.mycourses-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n  padding: 0.7rem 0.85rem;\n  border-radius: var(--mc-radius-sm);\n  background: rgba(245, 247, 252, 0.95);\n  border: 1px solid rgba(143, 155, 175, 0.12);\n}\n\n.mycourses-meta__label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--mc-soft);\n}\n\n.mycourses-meta__value {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--mc-ink);\n  word-break: break-word;\n}\n\n.mycourses-meta--accent {\n  background: rgba(249, 225, 190, 0.45);\n  border-color: rgba(249, 225, 190, 0.8);\n}\n\n.mycourses-meta--warn {\n  background: rgba(242, 196, 196, 0.4);\n  border-color: rgba(242, 196, 196, 0.75);\n}\n\n.mycourses-fee {\n  margin-top: 1.15rem;\n  padding: 1rem 1.1rem;\n  border-radius: var(--mc-radius-sm);\n  background: linear-gradient(\n    135deg,\n    rgba(249, 225, 190, 0.55),\n    rgba(242, 196, 196, 0.35)\n  );\n  border: 1px solid rgba(242, 196, 196, 0.55);\n}\n\n.mycourses-fee__title {\n  margin: 0 0 0.4rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--mc-ink);\n}\n\n.mycourses-fee__copy {\n  margin: 0 0 0.85rem;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: #3f4558;\n}\n\n.mycourses-fee__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.25rem;\n  margin-bottom: 0.9rem;\n}\n\n.mycourses-fee__stat strong {\n  display: block;\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--mc-soft);\n  margin-bottom: 0.15rem;\n}\n\n.mycourses-fee__stat span {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--mc-ink);\n}\n\n.mycourses-upload {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.mycourses-upload__label {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.mycourses-upload__input {\n  flex: 1 1 220px;\n  min-width: 0;\n  padding: 0.6rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid var(--mc-line-soft);\n  background: var(--mc-surface);\n  color: var(--mc-ink);\n  font-size: 0.9rem;\n}\n\n.mycourses-upload__input:focus {\n  outline: 2px solid rgba(213, 209, 253, 0.9);\n  outline-offset: 1px;\n}\n\n.mycourses-upload__btn {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  padding: 0.65rem 1.25rem;\n  border: none;\n  border-radius: 10px;\n  background: #2c3140;\n  color: #fff;\n  font-weight: 600;\n  font-size: 0.92rem;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease, opacity 0.15s ease;\n}\n\n.mycourses-upload__btn:hover:not(:disabled) {\n  background: #1f2430;\n  transform: translateY(-1px);\n}\n\n.mycourses-upload__btn:focus-visible {\n  outline: 2px solid rgba(213, 209, 253, 0.95);\n  outline-offset: 2px;\n}\n\n.mycourses-upload__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.mycourses-upload__filename {\n  margin: 0.55rem 0 0;\n  font-size: 0.82rem;\n  color: #3f4558;\n  word-break: break-all;\n}\n\n.mycourses-fee__note {\n  margin: 0.75rem 0 0;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  color: #5a5568;\n}\n\n.mycourses-subsection {\n  margin-top: 0.2rem;\n  padding: 0.95rem 1rem 1.05rem;\n  border-radius: 16px;\n  background: rgba(248, 249, 252, 0.85);\n  border: 1px solid rgba(143, 155, 175, 0.12);\n}\n\n.mycourses-subsection + .mycourses-subsection {\n  margin-top: 0.85rem;\n}\n\n.mycourses-subsection__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.25rem;\n}\n\n.mycourses-subsection__label {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--mc-ink);\n}\n\n.mycourses-subsection__count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.6rem;\n  height: 1.6rem;\n  padding: 0 0.45rem;\n  border-radius: 999px;\n  background: var(--mc-lavender);\n  color: var(--mc-ink);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.mycourses-subsection__hint {\n  margin: 0 0 0.75rem;\n  font-size: 0.84rem;\n  line-height: 1.4;\n  color: var(--mc-muted);\n}\n\n.mycourses-course-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 1rem;\n}\n\n.mycourses-course-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  min-width: 0;\n  min-height: 100%;\n  padding: 1.05rem 1.1rem 1.05rem 1.2rem;\n  border-radius: 18px;\n  background: #ffffff;\n  border: 1px solid rgba(143, 155, 175, 0.14);\n  box-shadow: 0 8px 20px rgba(52, 62, 94, 0.05);\n  text-align: left;\n  overflow: hidden;\n  transition:\n    border-color 0.18s ease,\n    box-shadow 0.18s ease,\n    transform 0.18s ease;\n}\n\n.mycourses-course-card:hover {\n  border-color: rgba(213, 209, 253, 0.75);\n  box-shadow: 0 14px 28px rgba(52, 62, 94, 0.1);\n  transform: translateY(-2px);\n}\n\n.mycourses-course-card__accent {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: var(--mc-lavender);\n}\n\n.mycourses-course-card--enrolled .mycourses-course-card__accent {\n  background: var(--mc-mint);\n}\n\n.mycourses-course-card--pending .mycourses-course-card__accent {\n  background: var(--mc-peach);\n}\n\n.mycourses-course-card--dropped .mycourses-course-card__accent,\n.mycourses-course-card--unenrolled .mycourses-course-card__accent {\n  background: var(--mc-pink);\n}\n\n.mycourses-course-card--transferred .mycourses-course-card__accent {\n  background: #c5d4f5;\n}\n\n.mycourses-course-card__header {\n  display: flex;\n  align-items: flex-start;\n  min-width: 0;\n}\n\n.mycourses-course-card__heading {\n  min-width: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.mycourses-course-card__title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.55rem;\n}\n\n.mycourses-course-card__title {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: 1.2rem;\n  font-weight: 700;\n  line-height: 1.3;\n  color: var(--mc-ink);\n}\n\n.mycourses-course-card__teacher {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #3f4558;\n}\n\n.mycourses-course-card__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.mycourses-soft-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.3rem 0.7rem;\n  border-radius: 999px;\n  font-size: 0.84rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #2c3140;\n}\n\n.mycourses-soft-chip--mint {\n  background: rgba(191, 241, 219, 0.8);\n  color: #1f3d32;\n}\n\n.mycourses-soft-chip--peach {\n  background: rgba(249, 225, 190, 0.9);\n  color: #5a4020;\n}\n\n.mycourses-soft-chip--lavender {\n  background: rgba(213, 209, 253, 0.85);\n  color: #3a3560;\n}\n\n.mycourses-course-card__facts {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.55rem;\n  padding: 0.75rem;\n  border-radius: 14px;\n  background: rgba(248, 249, 252, 0.95);\n  border: 1px solid rgba(143, 155, 175, 0.12);\n}\n\n.mycourses-course-card__fact {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.mycourses-course-card__fact--wide {\n  grid-column: 1 / -1;\n}\n\n.mycourses-course-card__fact-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--mc-soft);\n}\n\n.mycourses-course-card__fact-value {\n  font-size: 1.02rem;\n  font-weight: 600;\n  color: #2c3140;\n  word-break: break-word;\n}\n\n.mycourses-course-card__times {\n  white-space: pre-line;\n  line-height: 1.45;\n}\n\n.mycourses-course-card__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: auto;\n  padding-top: 0.15rem;\n}\n\n.mycourses-course-card__link,\n.mycourses-course-card__drop {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.52rem 0.9rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease, opacity 0.15s ease;\n}\n\n.mycourses-course-card__link {\n  background: var(--mc-lavender);\n  color: var(--mc-ink);\n}\n\n.mycourses-course-card__link:hover {\n  background: #d5d1fd;\n  color: var(--mc-ink);\n  text-decoration: none;\n  transform: translateY(-1px);\n}\n\n.mycourses-course-card__link--fee-due {\n  background: rgba(249, 225, 190, 0.85);\n  border-color: rgba(212, 161, 92, 0.45);\n}\n\n.mycourses-course-card__link--fee-due:hover {\n  background: rgba(249, 225, 190, 1);\n}\n\n.mycourses-course-card__drop {\n  background: rgba(242, 196, 196, 0.55);\n  color: #5a3030;\n  border-color: rgba(242, 196, 196, 0.9);\n}\n\n.mycourses-course-card__drop:hover:not(:disabled) {\n  background: rgba(242, 196, 196, 0.85);\n  transform: translateY(-1px);\n}\n\n.mycourses-course-card__drop:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.mycourses-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.28rem 0.65rem;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  flex-shrink: 0;\n}\n\n.mycourses-chip--enrolled {\n  background: var(--mc-mint);\n  color: #1f3d32;\n}\n\n.mycourses-chip--pending {\n  background: var(--mc-peach);\n  color: #5a4020;\n}\n\n.mycourses-chip--dropped,\n.mycourses-chip--unenrolled {\n  background: var(--mc-pink);\n  color: #5a3030;\n}\n\n.mycourses-chip--transferred {\n  background: #c5d4f5;\n  color: #24365f;\n}\n\n.mycourses-chip--other {\n  background: var(--mc-panel);\n  color: #3f4558;\n}\n\n.mycourses-chip--paid {\n  background: var(--mc-mint);\n  color: #1f3d32;\n}\n\n.mycourses-chip--unpaid {\n  background: var(--mc-pink);\n  color: #5a3030;\n}\n\n.mycourses-page--loading {\n  display: flex;\n  height: calc(100vh - 80px);\n  min-height: calc(100vh - 80px);\n  padding-top: 0;\n  padding-bottom: 0;\n  overflow: hidden;\n}\n\n.mycourses-page--loading .mycourses-page__inner {\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n  height: 100%;\n  min-height: 100%;\n}\n\n.mycourses-page--loading .mycourses-loading {\n  flex: 1 1 auto;\n  width: 100%;\n  height: 100%;\n  min-height: 100%;\n}\n\n.mycourses-empty,\n.mycourses-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 0.65rem;\n  padding: 2.5rem 1.5rem;\n  border-radius: var(--mc-radius);\n  background: rgba(255, 255, 255, 0.76);\n  border: 1px dashed rgba(143, 155, 175, 0.28);\n  color: var(--mc-muted);\n  box-shadow: none;\n}\n\n.mycourses-loading {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: stretch;\n  width: 100%;\n  height: calc(100vh - 80px);\n  min-height: calc(100vh - 80px);\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  color: var(--mc-muted);\n  overflow: hidden;\n}\n\n.mycourses-loading .education-loader {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n}\n\n.mycourses-empty__title,\n.mycourses-error__title {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--mc-ink);\n}\n\n.mycourses-empty__copy,\n.mycourses-error__copy {\n  margin: 0;\n  max-width: 28rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.mycourses-empty__cta,\n.mycourses-error__cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0.35rem;\n  padding: 0.65rem 1.2rem;\n  border-radius: 10px;\n  border: none;\n  background: var(--mc-lavender);\n  color: var(--mc-ink);\n  font-weight: 600;\n  font-size: 0.92rem;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.mycourses-empty__cta:hover,\n.mycourses-error__cta:hover {\n  background: #d5d1fd;\n  color: var(--mc-ink);\n  text-decoration: none;\n  transform: translateY(-1px);\n}\n\n.mycourses-empty__link {\n  margin-top: 0.15rem;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--mc-muted);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.mycourses-empty__link:hover {\n  color: var(--mc-ink);\n}\n\n.mycourses-subsection-empty {\n  margin: 0;\n  padding: 0.85rem 1rem;\n  border-radius: 12px;\n  background: rgba(245, 247, 252, 0.7);\n  border: 1px dashed rgba(143, 155, 175, 0.28);\n  color: var(--mc-soft);\n  font-size: 0.88rem;\n}\n\n/* Fee warning dialog */\n.mycourses-fee-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: safe center;\n  justify-content: center;\n  padding: 1.5rem;\n  overflow-y: auto;\n  background: rgba(18, 16, 26, 0.52);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.mycourses-fee-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(100%, 520px);\n  max-height: min(90vh, 680px);\n  margin: auto;\n  background: #fff;\n  color: var(--mc-ink);\n  border: 1px solid var(--mc-line);\n  border-radius: var(--mc-radius);\n  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.28);\n  overflow: hidden;\n}\n\n.mycourses-fee-dialog__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 1.2rem 1.35rem 1rem;\n  border-bottom: 1px solid var(--mc-line);\n  border-left: 4px solid #c45c5c;\n  background: #fff;\n}\n\n.mycourses-fee-dialog__header-text {\n  min-width: 0;\n}\n\n.mycourses-fee-dialog__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 2.25rem;\n  height: 2.25rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  border-radius: 999px;\n  background: #f4f4f6;\n  color: #1f1b2e;\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.mycourses-fee-dialog__close:hover {\n  background: #ebebef;\n}\n\n.mycourses-fee-dialog__eyebrow {\n  margin: 0 0 0.3rem;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #8a3030;\n}\n\n.mycourses-fee-dialog__title {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.3rem, 2.4vw, 1.5rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--mc-ink);\n}\n\n.mycourses-fee-dialog__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 1.15rem 1.35rem 1.35rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.mycourses-fee-dialog__intro {\n  margin: 0;\n  font-size: 0.92rem;\n  line-height: 1.45;\n  color: #3f4558;\n}\n\n.mycourses-fee-dialog__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.mycourses-fee-dialog__list li {\n  padding: 0.65rem 0.8rem;\n  border-radius: 10px;\n  background: #f7f7f9;\n  border: 1px solid rgba(31, 27, 46, 0.1);\n  font-size: 0.92rem;\n  font-weight: 650;\n  color: var(--mc-ink);\n}\n\n.mycourses-fee-dialog__amount-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  padding: 0.85rem 0.95rem;\n  border-radius: 12px;\n  border: 1px solid rgba(180, 70, 70, 0.28);\n  background: #fff;\n}\n\n.mycourses-fee-dialog__amount-label {\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #8a3030;\n}\n\n.mycourses-fee-dialog__amount-value {\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--mc-ink);\n}\n\n.mycourses-fee-dialog__disclaimer {\n  margin: 0;\n  padding: 0.75rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba(31, 27, 46, 0.1);\n  background: #fafafa;\n  font-size: 0.88rem;\n  line-height: 1.5;\n  color: #3f4558;\n}\n\n.mycourses-fee-dialog__wait {\n  padding: 0.85rem 0.95rem;\n  border-radius: 12px;\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  background: #f7f7f9;\n}\n\n.mycourses-fee-dialog__wait-label {\n  margin: 0 0 0.55rem;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--mc-soft);\n}\n\n.mycourses-fee-dialog .timer-container {\n  max-width: none;\n  margin: 0;\n  text-align: left;\n}\n\n.mycourses-fee-dialog .timer-text {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--mc-ink);\n  margin-bottom: 0.5rem;\n}\n\n.mycourses-fee-dialog .progress-bar {\n  height: 8px;\n  background: rgba(31, 27, 46, 0.08);\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.mycourses-fee-dialog .progress {\n  background: #c48a3a;\n  border-radius: 999px;\n}\n\n.mycourses-fee-dialog__continue {\n  width: 100%;\n  margin-top: 0.15rem;\n  padding: 0.8rem 1rem;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  background: #d8d8de;\n  color: #6f7588;\n  font-weight: 750;\n  font-size: 0.95rem;\n  cursor: not-allowed;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease,\n    opacity 0.15s ease, transform 0.15s ease;\n}\n\n.mycourses-fee-dialog__continue--ready,\n.mycourses-fee-dialog__continue:not(:disabled) {\n  background: var(--mc-lavender);\n  border-color: rgba(90, 80, 160, 0.22);\n  color: var(--mc-ink);\n  cursor: pointer;\n}\n\n.mycourses-fee-dialog__continue--ready:hover,\n.mycourses-fee-dialog__continue:hover:not(:disabled) {\n  background: #d5d1fd;\n  transform: translateY(-1px);\n}\n\n.mycourses-fee-dialog__continue:disabled {\n  opacity: 1;\n}\n\n.mycourses-fee-dialog__continue:focus-visible {\n  outline: 2px solid rgba(213, 209, 253, 0.95);\n  outline-offset: 2px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .mycourses-skeleton__bar,\n  .mycourses-skeleton__panel,\n  .mycourses-course-card,\n  .mycourses-upload__btn,\n  .mycourses-course-card__link,\n  .mycourses-course-card__drop {\n    animation: none;\n    transition: none;\n  }\n}\n\n@media (max-width: 1100px) {\n  .mycourses-meta-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 720px) {\n  .mycourses-page {\n    padding: 1rem 5% 2.5rem;\n  }\n\n  .mycourses-panel {\n    padding: 1rem;\n  }\n\n  .mycourses-panel--account {\n    padding: 1rem;\n  }\n\n  .mycourses-account {\n    align-items: stretch;\n  }\n\n  .mycourses-fee-actions {\n    width: 100%;\n  }\n\n  .mycourses-fee-action {\n    flex: 1 1 calc(50% - 0.3rem);\n    min-width: 0;\n  }\n\n  .mycourses-meta-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mycourses-panel__head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .mycourses-upload {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .mycourses-upload__btn {\n    width: 100%;\n  }\n\n  .mycourses-course-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mycourses-subsection {\n    padding: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
